module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAABHNCSVQICAgIfAhkiAAAANNJREFUOE/Nk20NwkAQRN84wAlIKAoACXWAhEooCpAADmgdIKEOwMGSaUpTSL8gIWF/XTa37+5m5kSnImIB3Lq9kXUBpHrfEBHJTEAOXGtAMxRzBiWVzUwGJIqIM7CZM9zsKSStI6IF+OSdJINGKyK2wEmSD34BrCVZlCmA9bn8BgDse7Q4SHK/rkbs/hsAd8A56FYlqZoF+AsNbNFywIZSUjalgd+/GgA4PMUo4AsN7E4dZSfx4yA9b2qA7TsCk1EGrFMqqbXbADfbsEzFGci7/+YBEyazmAsnb1YAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/examinatSystem/copyIcon.png
// module id = XmwG
// module chunks = 3